module.exports = __webpack_public_path__ + "img/9788936456214.52cc7d28.jpg";